module.exports = __webpack_public_path__ + "img/montenegro.2b8ef821.svg";